import { render, staticRenderFns } from "./MinmumPremiumModal.vue?vue&type=template&id=01bf3d58&scoped=true"
import script from "./MinmumPremiumModal.vue?vue&type=script&lang=js"
export * from "./MinmumPremiumModal.vue?vue&type=script&lang=js"
import style0 from "./MinmumPremiumModal.vue?vue&type=style&index=0&id=01bf3d58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bf3d58",
  null
  
)

export default component.exports